import BaseService from "../base";
import TLReviewStepService from "./tLReviewStepService";
class TLReviewService extends BaseService {
  createTLReviewProcedure = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("createTLReviewProcedure", para, success, error);
  };

  getTLReviewStepItem = (
    para: any,
    success: any,
    error: any,
    interfaceList: any,
    mergePayloadMap: any
  ) => {
    TLReviewStepService.getStepData(para, success, error, interfaceList, mergePayloadMap);
  };

  tlReviewTriggerStepAction = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("tlReviewTriggerStepAction", para, success, error);
  };

  checkTlReviewEdit = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("checkTlReviewEdit", para, success, error);
  };

  getFlowStepData = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getFlowStepData", para, success, error);
  };
}

const tlReviewService = new TLReviewService();

export default tlReviewService;
